export const calculateMuEff = (mu0, theta, vg, vth) => {
/**
 * 🔬 μeff (Effective Mobility) 계산 모듈
 * 
 * 📖 물리적 의미:
 * - 게이트 전압이 높아짐에 따라 다양한 산란 메커니즘으로 인해 발생하는 이동도 저하를 고려한 실제 이동도
 * - 산란 메커니즘: 표면 거칠기 산란, 계면 트랩으로 인한 쿨롱 산란 등
 * - 작동 중인 소자에서 캐리어 이동도를 보다 현실적으로 나타냄
 * 
 * 📏 측정 데이터: IDVG-Linear
 * - μ0 (Y-function으로 구한 저전계 이동도) 필요
 * - θ (mobility degradation factor) 필요
 * - 특정 VG 지점에서의 실제 유효 이동도 계산
 * 
 * 🧮 계산 수식: μeff = μ0 / (1 + θ(VG - Vth))
 * - μ0: 이상적인 저전계 이동도 (산란 없는 상태)
 * - θ: 이동도 저하 계수 (V⁻¹)
 * - VG: 동작 게이트 전압
 * - Vth: 문턱 전압
 * 
 * 💡 물리적 해석:
 * - VG가 증가할수록 μeff 감소 (더 많은 산란)
 * - θ가 클수록 이동도 저하가 심함
 * - 실제 동작 조건에서의 성능 예측에 중요
 */


  // 🔒 입력값 유효성 검사
  if (!mu0 || !theta || vg <= vth) return 0;
  
  // 🧮 μeff 계산: μeff = μ0 / (1 + θ(VG - Vth))
  // 
  // 물리적 의미:
  // - (VG - Vth): 실제 채널을 형성하는 유효 게이트 전압
  // - θ(VG - Vth): 게이트 전압에 의한 이동도 저하 정도
  // - 1 + θ(VG - Vth): 총 이동도 저하 인수
  // - μ0를 이 인수로 나누면 실제 유효 이동도
  return mu0 / (1 + theta * (vg - vth));
};